// This file is auto-generated.
// It's responsible for giving the view it's own Flow context.

import { Flow } from 'Simple/Flow'
import React from 'react'
import BrandLogo from './data'

export default function BrandLogoFlow({ children, ...props }) {
  return (
    <Flow viewPath={props.viewPath} flowDefinitionViewPathSource="/DesignSystem/BrandLogo">
      <BrandLogo {...props}>
        {children}
      </BrandLogo>
    </Flow>
  )
}
